import store from '../store';
import { get } from './http';

export const requestPV = async () => {
	if (['draft', 'preview'].includes(store.state.mode)) return;
	if (window.parent !== window) return;
	const bot = store.state.bot;
	const user = store.state.user;
	await get(process.env.VUE_APP_PV_HOST + '/log/pv', { b: bot.id, u: user.id, o: user.oid || user.token, ref: '/member' }, undefined, { noBase: true });
	await get(process.env.VUE_APP_PV_HOST + '/log/popup', { b: bot.id, u: user.id, o: user.oid || user.token, ref: '/member' }, undefined, { noBase: true });
}